import { GetVenueReservationsRangeQueryResponse } from "@/providers/ReservationsProvider/queries/GetVenueReservationsQuery";
import { TypePolicies } from "@apollo/client";

type ReservationsRange =
  NonNullable<GetVenueReservationsRangeQueryResponse["venuePortalUser"]>["reservations"];

export const venuePortalUserPolicies: TypePolicies = {
  VenuePortalUser: {
    fields: {
      reservationsRange: {
        keyArgs: false,
        merge(
          _existing: ReservationsRange | undefined,
          incoming: ReservationsRange,
        ) {
          return incoming;
        },
      },
    },
  },
};
